import { Line } from 'back_office/v2/redux/models/models'
export default Line.actions
